package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.single_sale_group.GetSalesGroup
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.sale_group.SaleItem
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.grid_function.GridFunction
import org.hs_soft.runmynesto.pages.components.grid_function.GridItemsList

@Composable
fun GridOptionBar(
    searchValue: String,
    windowSizeMode: WindowSizeModeEnum,
    infoList: List<SaleItem>,
    titleDescending: Boolean,
    numberDescending: Boolean,
    showNumberSortIcon: Boolean,
    showTitleSortIcon: Boolean,
    selectedItem: GetSalesGroup?,
    onSearchValueChange: (String) -> Unit,
    onTitleSortClick: () -> Unit,
    onNumberSortClick: () -> Unit,
    onSaleItemClick: (String) -> Unit,
    onAddRecord: () -> Unit,
    refreshList:()->Unit,
    onSwipeRight:()->Unit,
) {
    Column(
        modifier = Modifier
            .thenIf(
                windowSizeMode==WindowSizeModeEnum.PHONE,
                Modifier.fillMaxWidth()
            )
            .fillMaxHeight()

    )
    {

        Column(
            modifier = Modifier
                .thenIf(
                    windowSizeMode==WindowSizeModeEnum.PHONE,
                    Modifier.fillMaxWidth()
                )
                .weight(1f)
        ){

            CustomEditText(
                width = Dimen.gridWidth,
                label = "",
                fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
                value = searchValue,
                endIconPath = Res.PathIcon.searchBox,
                isRequired = false,
                hint = Strings.current().search,
                onFocusIn = {},
                onFocusOut = {},
                onInputChange = {it, validation ->
                    onSearchValueChange(it)
                },
            )

            GridFunction(
                modifier = Modifier,
                fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
                title = Strings.current().name,
                infoTitle = Strings.current().numberDot,
                footerTitle = Strings.current().items,
                showAddItemIcon = true,
                infoList = infoList,
                titleDescending = titleDescending ,
                numberDescending = numberDescending,
                showTitleSortIcon = showTitleSortIcon,
                showNumberSortIcon = showNumberSortIcon,
                onTitleSortClick = {
                    onTitleSortClick()
                },
                onNumberSortClick = {
                    onNumberSortClick()
                },
                onAddItemClick = {
                     onAddRecord()
                },
                refreshList = {
                    refreshList()
                },


            ) {
                GridItemsList(
                    id = selectedItem?.id ?: "",
                    items = infoList,
                    onItemClick = {
                        onSaleItemClick(it)
                    },
                )
            }
        }






    }
}